// extracted by mini-css-extract-plugin
module.exports = {"terms":"SignLeaseTerms_terms__UdUBU","secParagraph":"SignLeaseTerms_secParagraph__RBuCu"};